/**
 * yd-nav-scroll: 导航滚动缩放。
 * scrollY > 24 时给 [data-nav-scroll] 加 .is-scrolled。
 * 源自 web-hand-off/cla/assets/js/nav-scroll.js，新增 shopify:section:load 适配主题编辑器。
 */
(function () {
  function markActive(nav) {
    const here = window.location.pathname.replace(/\/index\.html?$/, '/');
    nav.querySelectorAll('.nav__link').forEach((a) => {
      const href = (a.getAttribute('href') || '').replace(/\/index\.html?$/, '/');
      const on = href === window.location.pathname || href === here;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  function initMenu(nav) {
    const toggle = nav.querySelector('[data-nav-toggle]');
    if (!toggle || nav.dataset.menuReady === '1') return;
    nav.dataset.menuReady = '1';
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('.nav__menu .nav__link').forEach((a) => {
      a.addEventListener('click', () => {
        nav.classList.remove('is-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    const nav = document.querySelector('[data-nav-scroll]');
    if (!nav) return;
    markActive(nav);
    initMenu(nav);
    if (nav.dataset.navScrollReady) return;
    nav.dataset.navScrollReady = '1';
    let raf = null;
    function apply() {
      raf = null;
      nav.classList.toggle('is-scrolled', window.scrollY > 24);
    }
    function onScroll() {
      if (raf == null) raf = requestAnimationFrame(apply);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
